import { render, staticRenderFns } from "./myGalleryTop.vue?vue&type=template&id=0a6bb089&scoped=true&"
import script from "./myGalleryTop.vue?vue&type=script&lang=js&"
export * from "./myGalleryTop.vue?vue&type=script&lang=js&"
import style0 from "./myGalleryTop.vue?vue&type=style&index=0&id=0a6bb089&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6bb089",
  null
  
)

export default component.exports